






















import Vue from "vue";
import Component from "vue-class-component";
import ChatBotDrawer from "@/components/Ai/ChatBotDrawer.vue";

@Component({
    components: {
        ChatBotDrawer,
    },
})
export default class ChatBot extends Vue {
    private isOpened: boolean = false;
}
